import { render, staticRenderFns } from "./EmployeeBranchFloatBtns.vue?vue&type=template&id=124f79d0&"
import script from "./EmployeeBranchFloatBtns.vue?vue&type=script&lang=js&"
export * from "./EmployeeBranchFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports